export default __webpack_public_path__ + "static/media/player-skip-forward.6854e0a4.svg";